import { useMutation, gql } from '@apollo/client';
import {
  EditarFeriadoMutation,
  EditarFeriadoMutationVariables,
} from './__generated__/EditarFeriadoMutation';

const EDITAR_FERIADO_MUTATION = gql`
  mutation EditarFeriadoMutation($id_feriado: Int!, $dsc_feriado: String, $dat_feriado: String) {
    editarFeriado(
      input: { id_feriado: $id_feriado, dsc_feriado: $dsc_feriado, dat_feriado: $dat_feriado }
    ) {
      id_feriado
      dsc_feriado
      dat_feriado
    }
  }
`;

const useEditarFeriadoMutation = () => {
  return useMutation<EditarFeriadoMutation, EditarFeriadoMutationVariables>(
    EDITAR_FERIADO_MUTATION
  );
};

export { useEditarFeriadoMutation };
